import { render, staticRenderFns } from "./Cuadrantes.vue?vue&type=template&id=6c9bbfff&"
import script from "./Cuadrantes.vue?vue&type=script&lang=js&"
export * from "./Cuadrantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports